import styled, { css } from 'styled-components';
import { media } from '../../utils';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9997;
  display: flex;
  justify-content: center;
  padding-top: 80px;
`;

export const SearchModal = styled.div`
  width: 650px;
  max-height: 80vh;
  background: #0a0a2e;
  border: 1px solid rgba(51, 255, 153, 0.3);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);

  ${media('mobile')} {
    width: calc(100vw - 20px);
    max-height: 90vh;
  }
`;

export const SearchHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(51, 255, 153, 0.15);
`;

export const SearchTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  color: #fff;
  margin: 0;
`;

export const ModeToggle = styled.div`
  display: flex;
  gap: 4px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 3px;
`;

export const ModeBtn = styled.button<{ $active: boolean }>`
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s;

  ${({ $active }) => $active
    ? css`
        background: rgba(51, 255, 153, 0.2);
        color: #33ff99;
      `
    : css`
        background: transparent;
        color: #888;
      `
  }
`;

export const SearchForm = styled.form`
  display: flex;
  gap: 8px;
  padding: 16px 20px;
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  font-size: 1rem;
  outline: none;

  &:focus {
    border-color: #33ff99;
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.3);
  }
`;

export const SearchBtn = styled.button`
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  background: #33ff99;
  color: #000;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s;

  &:disabled {
    opacity: 0.5;
  }
`;

export const AISummary = styled.div`
  margin: 0 20px 12px;
  padding: 10px 14px;
  background: rgba(51, 255, 153, 0.08);
  border: 1px solid rgba(51, 255, 153, 0.2);
  border-radius: 10px;
  color: #ccc;
  font-size: 0.85rem;
  line-height: 1.5;
  white-space: pre-wrap;
`;

export const ResultsList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 20px 16px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(51, 255, 153, 0.3);
    border-radius: 4px;
  }
`;

export const ResultItem = styled.div`
  display: flex;
  gap: 12px;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }
`;

export const ResultThumb = styled.div<{ $url?: string }>`
  width: 80px;
  height: 50px;
  border-radius: 6px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: #888;
  background: ${({ $url }) => $url ? `url(${$url}) center/cover` : 'rgba(255,255,255,0.05)'};
`;

export const ResultInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-width: 0;
`;

export const ResultTitle = styled.div`
  color: #fff;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ResultMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  color: #888;
`;

export const TypeBadge = styled.span<{ $type: string }>`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  text-transform: uppercase;

  ${({ $type }) => {
    switch ($type) {
      case 'video': return css`background: rgba(255, 100, 100, 0.15); color: #ff6464;`;
      case 'image': return css`background: rgba(100, 150, 255, 0.15); color: #6496ff;`;
      case 'audio': return css`background: rgba(255, 200, 50, 0.15); color: #ffc832;`;
      default: return css`background: rgba(255,255,255,0.1); color: #aaa;`;
    }
  }}
`;

export const NoResults = styled.div`
  text-align: center;
  color: #666;
  padding: 40px 0;
  font-size: 0.95rem;
`;
